import BPLogoLoader from 'components/BionicUI/loading/BPLogoLoader';
import { useAuth } from 'context/auth.context';
import { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'routes';

type ProtectedRoutesProps = {
  component: ComponentType;
};

const ProtectedRoutes = ({ component: Component }: ProtectedRoutesProps) => {
  const { isLoggedIn } = useAuth();
  if (typeof isLoggedIn === 'undefined') {
    return (
      <div className="grid w-full h-full place-content-center">
        <BPLogoLoader className="w-[30vw] sm:w-[20vw] lg:w-[15vw] xl:w-[10vw]" />
      </div>
    );
  }

  if (!isLoggedIn) {
    return <Navigate to={ROUTES.LOGIN} />;
  }

  return <Component />;
};

export default ProtectedRoutes;
